import templateSelection from '../../../../Template/config/components/selection'
import presetSelect from './PresetSelect'
import setBuilder from './SetBuilder'
import search from './Search'

export default {
    ...templateSelection,
    presetSelect,
    setBuilder,
    search
}


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryCovid/config/components/selection/index.js